export default __webpack_public_path__ + "static/media/mainecoon.0fd43eef.mp4";